<template>
  <div>
    <p class="text-muted">
      Toplam {{ projectListMetaData.totalCount }} sonuç bulundu
    </p>
    <b-table
        :items="projectList"
        :fields="projectListHeaders.filter(item => item.visible)"
        hover
        responsive
        sort-icon-left
        :per-page="perPage"
        :busy="projectListLoading"
        show-empty
        head-row-variant="info"
        table-variant="white"
    >
      <template #empty="scope">
        <h6 class="text-center my-5">
          {{ scope.loading ? "Lütfen Bekleyin" : noProjectMessage }}
        </h6>
      </template>
      <template #cell(createDate)="data">
        <span>{{ formattedDate(data.item.createDate, "DD-MM-YYYY") }}</span>
      </template>
      <template #cell(startDate)="data">
        <span>{{ formattedDate(data.item.startDate, "DD-MM-YYYY") }}</span>
      </template>
      <template #cell(endDate)="data">
        <span>{{ formattedDate(data.item.endDate, "DD-MM-YYYY") }}</span>
      </template>
      <template #cell(createUser)="data">
        <span>{{ data.item.createUser.firstName + ' ' + data.item.createUser.lastName }}</span>
      </template>
      <template #cell(status)="data">
        <v-chip small label :color="data.item.status === 2 ? 'success ligthen-2' : 'secondary ligthen-2'">
          {{ data.item.status === 2 ? 'Onaylandı' : 'Onay Bekliyor' }}
        </v-chip>
      </template>
      <template #cell(process)="data">
        <div>
          <v-menu
              :v-model="showActionsMenu"
              bottom
          >
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                  class="mx-1"
                  small
                  color="primary"
                  v-bind="attrs"
                  v-on="on"
                  @click="showActionsMenu = true"
              >
                İşlemler
              </v-btn>
            </template>

            <v-list>
              <v-list-item
                  v-if="userRoleId === 1 || userRoleId === '1' || userRoleId === 2 || userRoleId === '2' && projectList.isVisible "
                  @click="openEditProjectDialog('edit',data.item)"
              >
                <v-list-item-icon>
                  <v-icon>mdi-eye</v-icon>
                </v-list-item-icon>
                <v-list-item-title>Detay</v-list-item-title>
              </v-list-item>
              <v-list-item
                  v-show="data.item.status === 1"
                  @click="projectApprove({params: {},body: {},urlSegments: [data.item.id]})"
              >
                <v-list-item-icon>
                  <v-icon color="primary"> mdi-check-decagram</v-icon>
                </v-list-item-icon>
                <v-list-item-title>Projeyi Onayla</v-list-item-title>
              </v-list-item>
              <v-list-item
                  v-if="data.item.status !== 2"
                  @click="projectDelete({
                    params: {},
                    body: {},
                    urlSegments: [data.item.id]
                  })"
              >
                <v-list-item-icon>
                  <v-icon color="danger"> mdi-basket-remove</v-icon>
                </v-list-item-icon>
                <v-list-item-title>Projeyi Sil</v-list-item-title>
              </v-list-item>
              <v-list-item
                  @click="openProjectOrdersDialog(data.item)"
              >
                <v-list-item-icon>
                  <v-icon>mdi-cart</v-icon>
                </v-list-item-icon>
                <v-list-item-title>Siparişler</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </div>

      </template>
    </b-table>
    <NewProjectDialog
        :showDialog="newProjectDialog"
        :processType="dialogType"
        @dialogChange="(e) => (newProjectDialog = e)"
        :project-id="selectedProject"
    ></NewProjectDialog>
      <ProjectOrdersDialog
          :showDialog="projectOrdersDialog"
          @dialogChange="(e) => (projectOrdersDialog = e)"
          :selectedProject="selectedProject"
      ></ProjectOrdersDialog>
  </div>
</template>

<script>
import {mapActions, mapState} from "vuex";
import {formattedDate} from "@/momentHelper";
import NewProjectDialog from "@/components/project/dialogs/NewProjectDialog.vue";
import ProjectOrdersDialog from "@/components/project/dialogs/ProjectOrdersDialog.vue";

export default {
  props: {
    perPage: {
      type: Number
    },
    currentPage: {
      type: Number
    }
  },
  components: {ProjectOrdersDialog, NewProjectDialog},
  computed: {
    ...mapState("auth", ["user"]),
    ...mapState("project", [
      "projectList",
      "projectListHeaders",
      "projectListLoading",
      "projectListMetaData",
      "noProjectMessage",
    ]),
  },
  data() {
    return {
      showActionsMenu: false,
      dialogType: null,
      newProjectDialog: false,
      selectedProject: null,
      userRoleId: this.$store.state.auth.user.RoleGroupId,
      demoProjectDialog: false,
      projectOrdersDialog: false,
    };
  },
  methods: {
    ...mapActions("project", ["projectDelete", "projectApprove"]),
    formattedDate,
    openEditProjectDialog(type, item) {
      this.dialogType = type;
      this.selectedProject = item;
      this.newProjectDialog = true;
    },
    openProjectOrdersDialog(item) {
      this.selectedProject = item;
      this.projectOrdersDialog = true;
    }
  },
  watch: {}
};
</script>